import { render, staticRenderFns } from "./PolicyTabsItem.vue?vue&type=template&id=7777a5e6&scoped=true"
import script from "./PolicyTabsItem.vue?vue&type=script&lang=js"
export * from "./PolicyTabsItem.vue?vue&type=script&lang=js"
import style0 from "./PolicyTabsItem.vue?vue&type=style&index=0&id=7777a5e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7777a5e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardTitle,VCol,VFlex,VRow,VSelect})
